var resizeTimer;
const videos = document.querySelectorAll('.vid-responsive');

function swapVideoSrc(video, vidFormat) {
  const currentUrl = video.querySelector('source').src;
  const newUrl = vidUrl + video.dataset.vidName + '-' + vidFormat + '.mp4'; // vidUrl is global

  if (newUrl !== currentUrl) {
    video.querySelector('source').src = newUrl;
    video.load();
    if (
      typeof video.autoplay !== typeof undefined &&
      video.autoplay !== false
    ) {
      video.play();
    }
  }
}

function getVideoFormat(video) {
  let vidFormat = 'mobile';
  const classList = video.className.split(' ');
  const formatClass = document.getElementsByClassName(
    classList[classList.length - 1]
  );
  vidFormat = getComputedStyle(formatClass[0])
    .getPropertyValue('--video-format')
    .trim();
  return vidFormat;
}

function resizeVideo(video) {
  let vidFormat = getVideoFormat(video);
  swapVideoSrc(video, vidFormat);
}

function resizeVideos() {
  videos.forEach((video) => {
    resizeVideo(video);
  });
}

function onWindowResize() {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function() {
    resizeVideos();
  }, 500);
}

export default () => {
  // Resize all videos on load
  resizeVideos();
  var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  if (!isIOS && !window.innerWidth < 550) {
    window.addEventListener('resize', onWindowResize);
  }
};
